import { render, staticRenderFns } from "./InsertBulk.vue?vue&type=template&id=78c4be4e&scoped=true"
import script from "./InsertBulk.vue?vue&type=script&lang=js"
export * from "./InsertBulk.vue?vue&type=script&lang=js"
import style0 from "./InsertBulk.vue?vue&type=style&index=0&id=78c4be4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4be4e",
  null
  
)

export default component.exports